import React from 'react';

import { useAppSelector } from '@pkg/hooks';

import { StatsItem } from './StatsItem';

import { Wrapper } from './styles';

export const Stats = () => {
    const marketplaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceEnabled);
    if (!marketplaceEnabled) return null;

    return (
        <Wrapper>
            {/* TODO: Confirm if we want to share different curency totals */}
            {/*<StatsItem label="Net worth" value={32475.15} currency="usd" subLabel="24h" diffPercent={25} />*/}

            {/* TODO: Add back once we get totals */}
            {/*<StatsItem label="Collectibles" value={14531} />*/}

            <StatsItem label="Listed" value={5} />
            <StatsItem label="Offers" value={52} subLabel="24h" diffNumber={3} diffDirection="down" />
        </Wrapper>
    );
};
